import React, { FunctionComponent } from 'react';
import cx from 'ui/helper/prefixed-class-names';
import Translate from 'ui/atoms/translate';
import { UserDataSet } from 'ui/types/user-data-set';
import Hint from 'ui/atoms/hint';
import CardItem from 'src/ui/atoms/card-item';

export interface IssuerUserInformationProps {
  /** Additional classes. */
  className?: string;

  userDataSet: UserDataSet;

  canAddIdentification: boolean;
}

const IssuerUserInformation: FunctionComponent<IssuerUserInformationProps> = (props) => {
  const { className, userDataSet, canAddIdentification } = props;

  return (
    <div className={cx('user-information', className)}>
      {Object.entries(userDataSet.fields).map((value: any, key: number) => (
        <CardItem title={value[1].label} content={value[1].value} key={key} />
      ))}
      {!canAddIdentification && userDataSet.key === 'personalData' && (
        <Hint variant="info">
          <Translate name={'dashboardInvestorSettings.personalData.hint'} />
        </Hint>
      )}
    </div>
  );
};

export default IssuerUserInformation;
